import React, { useContext, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { BlockStack } from "@shopify/polaris";

// import helpers
import { baseHelper, errorHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";

// import helpers components
import { Spinner } from "lib/components";

// import constant
import constant from "lib/constant/constant";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import gql
import { CONNECT_STRIPE_VENDOR } from "app/setup/apollo/mutations";
import { useLocation, useNavigate } from "react-router-dom";

const StripeCallback = () => {
  const { currentUser, isLoading, cms } = useContext(PrivateContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { gql } = constant;
  const { _id: id } = currentUser;
  const [connectToStripe, { loading }] = useMutation(CONNECT_STRIPE_VENDOR);
  const { code, state } = baseHelper.getQueryParams(location.search);

  const redirectRoute = "/payment-connect";

  const connect = async () => {
    try {
      console.log("Stripe callback loading");

      const response = await connectToStripe({ variables: { input: { code, state } } });

      const responseData = baseHelper.getResponseData(response.data, gql.CONNECT_STRIPE_VENDOR);
      const responseError = baseHelper.getResponseError(response.data, gql.CONNECT_STRIPE_VENDOR);

      if (responseError) {
        navigate(redirectRoute, { isStripeConnected: false, message: responseError });
      }

      if (responseData) {
        navigate(redirectRoute, {
          isStripeConnected: true,
        });
      }
    } catch (exception) {
      navigate(redirectRoute, {
        message: errorHelper.parse(exception),
        isStripeConnected: false,
      });
    }
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (code) {
      connect();
    } else {
      navigate(redirectRoute);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, code, navigate]);

  if (loading || isLoading) {
    return <Spinner fontSize={42} />;
  }

  if (id !== state) {
    return <BlockStack gap="2">{cms("common.message.error.notFound")}</BlockStack>;
  }

  return null;
};

export default withErrorBoundary(StripeCallback);
